import React, { useCallback, useEffect } from 'react'
import { BsGrid, BsGrid1X2 } from 'react-icons/bs'
import { Stack, Switch } from '@chakra-ui/react'
import rootStore from '../../../store/RootStore'

const NavbarSwitchChartViewMode = () => {
  const {
    reportStore: { setViewType, viewType },
  } = rootStore

  useEffect(() => {
    return () => setViewType({ value: '2x2' })
  }, [setViewType])

  const toggleView = useCallback(
    e => {
      if (!e.target.checked) {
        setViewType({ value: 'full' })
      } else {
        setViewType({ value: '2x2' })
      }
    },
    [setViewType]
  )

  return (
    <Stack direction="row">
      <BsGrid1X2 className="ms-3 text-1xl" />
      <Switch
        size="sm"
        onChange={toggleView}
        defaultChecked={true}
      />
      <BsGrid className="ms-3 text-1xl" />
    </Stack>
  )
}

NavbarSwitchChartViewMode.propTypes = {}

export { NavbarSwitchChartViewMode }
